



















import Vue from 'vue'
import HiddenBox from '@/components/HiddenBox.vue'
import IList from '@/types/components/IList.interface'
export default Vue.extend({
    components: { HiddenBox },
    props: {
        //  Determines if the component is shown
        hidden: {
            type: Boolean,
            default: false
        },
        //  The iList Vue instance that the component is targeting
        target: {
            type: Object,
            required: true
        }
    },
    data: () => ({
        selectPageValue: false,
        iListId: null
    }),
    mounted() {
        this.iListId = this.target.id
    },
    computed: {
        hotKeysEnabled(): boolean {
            // Checks if our hotkeys are enabled or not
            return this.$store.getters.settingGet('hotKeysEnabled')
        },
        iList(): IList {
            return this.$store.getters.iList(this.iListId)
        }
    },
    methods: {
        onSelectPageChange(bool: Boolean): void {
            //  If the checkbox is 'true', select page
            if (bool) this.target.selectPage()
            //  Else, checkbox must be false, reset multiSelected
            else this.target.selectPageReset()
        },
        setMultiSelect(bool: Boolean, hotKeyPressed: boolean = false): void {
            // True/false value if hotkey was used to activate function
            const hotKeyPressedAndOn = hotKeyPressed && this.hotKeysEnabled.enabled

            // True/false value if click was used to activate function
            const clickPress = !hotKeyPressed

            // If our hotkeys aren't on and the event wasn't activated with a click we leave the function
            if (!hotKeyPressedAndOn && !clickPress) {
                return
            }

            //  Get the iList
            const iList = this.iList

            // Chooses html anchor id based off what state multiselect is in (open/closed)
            const selectOrDoneHTMLID = bool ? 'select' : 'done'

            // For some reason we must click select if we are in a messagechannel to get multiselect (only for hotkey use)
            if (hotKeyPressedAndOn) {
                const dom = document.getElementById(selectOrDoneHTMLID)
                // Mimic clicking select
                dom.click()
            }

            //  Toggle the multiselect property
            iList.multiSelect = bool

            //  Unselect channels in the inbox
            //  Done for correctly rendering multi-select state in the inbox
            this.$store.commit('inboxSelectedChannelSet', null)

            //  Commit the changes (so they are reactive)
            this.$store.commit('iListSet', iList)

            //  If multiselect is 'false' we want to reset selections
            if (!bool) {
                this.selectPage = false
                this.target.selectPageReset()
            }
        }
    },
    watch: {
        iList: {
            deep: true,
            handler(val: IList): void {
                this.selectPageValue = val.selectPage
            }
        }
    }
})
